import React from "react";
import { Box } from "@mui/material";

const NoSearchHits = (): JSX.Element => {
  return (
    <Box minHeight="20vh">
      <i className="fas fa-info-circle"></i>&nbsp; Försök att ändra sökord eller filter.
    </Box>
  );
};

export default NoSearchHits;
